import React, { useState, useEffect } from "react";

import Swoodle from "../../../Assets/Images/swoodleLogo.svg";
import Backtick from "../../../Assets/Images/backtick.svg";
import { ReactComponent as DownArrow } from "../../../Assets/Icons/Down Arrow.svg";

import FundariserSidebar from "../common/FundraiserSidebar";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import FundraiserHeader from "../common/FundraiserHeader";
import PrimaryButton from "../../common/PrimaryButton";
import Selector from "../../common/Selector";
import { useFormik } from "formik";
import {
  subscriptionSchema,
  fundraiserSchema,
} from "../../../utils/validationSchemas";
import {
  getFundraiserCategories,
  updateReferredBy,
} from "../../../services/fundraiserService";
import { checkout, upgradeSubscription, getSubscriptionPlans, renewSubscription } from "../../../services/subscriptionService";
import { setSelectedPlan } from "../../../redux/slices/subscriptionSlice";
import Loader from "../../common/Loader";
import toast from "../../../utils/toast";

function Subscription() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const selectedPlan = useSelector(
    (state) => state?.subscriptionReducer?.selectedPlan
  );
  
  const activeSubscription = useSelector(
    (state) => state?.subscriptionReducer?.subscription
  );
  const loading = useSelector((state) => state?.subscriptionReducer?.loading);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const currentPath = location.pathname;
  const isUpgrade = searchParams.get("upgrade") === "true";
  const content = useSelector(
    (state) => state.fundraiserReducer.fundraiserContent
  );

  const [fundraiserCategories, setFundraiserCategories] = useState([]);
  const [fundraisers, setFundraisers] = useState([]);
  const [subscriptionPlans, setSubscriptionPlans] = useState([]);

  const getCategories = async () => {
    try {
      const result = await dispatch(getFundraiserCategories()).unwrap();
      setFundraiserCategories(result?.data);
    } catch (error) {
      console.error("Error fetching categories", error);
    }
  };

  const fetchSubscriptionPlans = async () => {
    try {
      const result = await dispatch(getSubscriptionPlans({})).unwrap();
      if (result?.success === true && result?.data?.length > 0) {
        setSubscriptionPlans(result.data);
        // If no plan is selected, default to the first plan (usually premium)
        if (!selectedPlan) {
          dispatch(setSelectedPlan(result.data[0]));
        }
      } else {
        toast.error("No subscription plans available. Please try again later.");
        setSubscriptionPlans([]);
      }
    } catch (error) {
      console.error("Error fetching subscription plans:", error);
      toast.error("Failed to load subscription plans. Please check your connection and try again.");
      setSubscriptionPlans([]);
    }
  };

  // Removed demo/fallback plans. We now rely solely on backend plans.

  useEffect(() => {
    getCategories();
    fetchSubscriptionPlans();
    
    // Fallback timeout to prevent infinite loading
    const timeout = setTimeout(() => {
      setIsLoading(false);
    }, 5000); // 5 seconds timeout
    
    return () => clearTimeout(timeout);
  }, []);

  // Fetch plans again if selectedPlan is null (in case user navigates directly to this page)
  useEffect(() => {
    if (!selectedPlan && subscriptionPlans.length === 0) {
      fetchSubscriptionPlans();
    }
  }, [selectedPlan, subscriptionPlans.length]);

  const initialValues = {
    category: "",
    fundraiser: "",
  };

  const formik = useFormik({
    initialValues: initialValues,
    // validationSchema: content == null ? subscriptionSchema : fundraiserSchema,

    onSubmit: async (values) => {
      try {
        // Check if we have a valid selected plan
        if (!selectedPlan || !selectedPlan.priceId) {
          toast.error("Please select a subscription plan first.");
          return;
        }

        // if (isUpgrade && activeSubscription) {
        //   // Handle upgrade/downgrade
        //   const upgradePayload = {
        //     subscriptionId: activeSubscription?.subscriptionId,
        //     newPriceId: selectedPlan?.priceId,
        //     currentPriceId: activeSubscription?.priceId,
        //   };
          
        //   const upgradeResult = await dispatch(upgradeSubscription(upgradePayload)).unwrap();
          
        //   if (upgradeResult?.success === true) {
        //     if (upgradeResult?.data?.url) {
        //       window.location.href = upgradeResult.data.url;
        //     } else {
        //       toast.success("Subscription updated successfully!");
        //       navigate("/existing-subscription");
        //     }
        //   } else {
        //     navigate("/subscription-failed");
        //   }
        // } 
        
        
        
        if (isUpgrade && activeSubscription) {
  const renewPayload = { priceId: selectedPlan?.priceId };
  const renewResult = await dispatch(renewSubscription(renewPayload)).unwrap();

  if (renewResult?.success === true && renewResult?.data?.url) {
    window.location.href = renewResult.data.url;
  } else {
    toast.success("Subscription renewed successfully!");
    navigate("/existing-subscription");
  }
}  
        else {
          // Handle new subscription
          const payload = {
            // Backend expects the Stripe priceId key
            priceId: selectedPlan.priceId,
          };

          const checkoutPromise = await dispatch(checkout(payload))?.unwrap();
          if (checkoutPromise?.success === true) {
            window.location.href = checkoutPromise?.data?.url;
          } else {
            navigate("/subscription-failed");
          }
        }
      } catch (err) {
        console.log("Checkout error:", err);
        navigate("/subscription-failed");
      }
    },
  });

  const { category, fundraiser } = formik.values;

  const {
    handleChange,
    handleBlur,
    errors,
    touched,
    setFieldValue,
    handleSubmit,
  } = formik;

  const titles = [
    { name: "Fundraising", completed: true },
    {
      name: "Payment Details",
      completed:
        currentPath.includes("/more-information") ||
        currentPath.includes("/submit-information")
          ? true
          : false,
    },
  ];

  const updateRefer = () => {
    fundraisers?.map(async (f) => {
      if (f?.user?.name === fundraiser) {
        const payload = { referredBy: f?.user?._id };
        const updatePromise = await dispatch(
          updateReferredBy(payload)
        )?.unwrap();
        if (updatePromise?.success === true) {
        }
      }
    });
  };

  useEffect(() => {
    updateRefer();
    
    // Fallback timeout to prevent infinite loading
    const timeout = setTimeout(() => {
      setIsLoading(false);
    }, 5000); // 5 seconds timeout
    
    return () => clearTimeout(timeout);
  }, [fundraisers, fundraiser]);
  
  return (
    <>
      <FundraiserHeader />
      {(loading || isLoading) && <Loader />}
      {!loading && !isLoading && (
        <div className="flex w-full">
          <div className="w-[0%] sm:w-[25%] md:w-[23%] lg:w-[28%] 2xl:w-[30%]">
            <FundariserSidebar titles={titles} />
          </div>
          <div className="w-[100%] sm:w-[65%] md:w-[55%] lg:w-[45%] 2xl:w-[40%] bg-[#FAFAFA] flex flex-col px-4 sm:px-7">
            {content !== null ? (
              <div className="w-[100%] flex justify-between mt-5 mb-10 sm:mt-12 sm:mb-24">
                <div className="flex">
                  <div className="pt-[9px] cursor-pointer">
                    <img src={Backtick} className="w-[9px]" />
                  </div>
                  <div className="flex flex-col pl-[30px]">
                    <span className="font-poppins font-[500] text-[18px] sm:text-[22px] mb-2 text-[#303030]">
                      Fundraising
                    </span>
                    <span className="flex justify-end font-[400] font-poppins text-[14px] text-[#303030] ">
                      {content?.user?.name}
                    </span>
                  </div>
                </div>
                <img src={content?.logo} className="w-[40px] sm:w-[50px]" />
              </div>
            ) : (
              <>
                <div className="w-[100%] flex justify-between items-start mt-5 mb-10 sm:my-12 gap-1 sm:gap-0">
                  <div className="flex flex-col">
                    <span className="font-poppins font-[500] text-[18px] sm:text-[22px] mb-2 text-[#303030]">
                      Choose Your Membership
                    </span>
                    <span className="flex justify-end font-[400] font-poppins text-[14px] text-[#303030] ">
                      Your membership purchase goes directly towards your
                      selected subscription plan.
                    </span>
                  </div>
                  <img
                    src={Swoodle}
                    className="w-[60px] sm:w-[80px] md:w-[100px] lg:w-[120px] mt-[4px]"
                  />
                </div>
                {/* <div className="mb-12 selectFundraiser">
                  <Selector
                    label={""}
                    labelClassName="lg:text-[14px] sm:text-[12px] font-[400] text-[#303030] mb-2 font-poppins lg:leading-[27px] sm:leading-[21px]"
                    divClassName="w-[100%]"
                    selectClassName="w-full mb-2 h-[40px] sm:h-[45px] rounded-[8px] bg-[#FFFFFF] text-[#303030] text-[14px] font-[400] outline-none !font-poppins !focus:outline-none !border-none shadow-[0_4px_4px_0px_rgba(0,0,0,0.06)]"
                    flexClassName="gap-1"
                    options={fundraiserCategoriesOptions}
                    suffixIcon={<DownArrow />}
                    placeholder={"Select Fundraiser Category"}
                    selectFundraiser={true}
                    onChange={handleCategoryChange}
                    handleBlur={handleBlur}
                    error={errors.category}
                    touched={touched.category}
                  />
                  {category !== "" && (
                    <Selector
                      label={""}
                      labelClassName="lg:text-[14px] sm:text-[12px] font-[400] text-[#303030] mb-2 font-poppins lg:leading-[27px] sm:leading-[21px]"
                      divClassName="w-[100%]"
                      selectClassName="w-full h-[40px] sm:h-[45px] rounded-[8px] bg-[#FFFFFF] text-[#303030] text-[14px] font-[400] outline-none !font-poppins !focus:outline-none !border-none shadow-[0_4px_4px_0px_rgba(0,0,0,0.06)]"
                      flexClassName="gap-1"
                      options={fundraisersOptions}
                      suffixIcon={<DownArrow />}
                      placeholder={"Select Fundraiser"}
                      value={fundraiser}
                      selectFundraiser={true}
                      onChange={handleFundraiserChange}
                      handleBlur={handleBlur}
                      error={errors.fundraiser}
                      touched={touched.fundraiser}
                    />
                  )}
                </div> */}
              </>
            )}

            {/* Current Plan Card */}

            <div className="w-[100%]">
              <div className="w-full sm:px-11 flex justify-between items-center">
                <div className="">
                  <span className="font-[500] text-[16px] font-poppins text-[#303030] overflow-wrap">
                    Your order details
                  </span>
                </div>
                <div className="">
                  <span className="flex font-[600] text-[16px] font-poppins font text-[#303030]  overflow-wrap ">
                    ${selectedPlan?.amount ? selectedPlan?.amount : (subscriptionPlans.length > 0 ? subscriptionPlans[0]?.amount || "0" : "Loading...")}
                  </span>
                </div>
              </div>

              <div
                className="rounded-[10px] border-[2px] border-[#00ADEF4D] mt-5 sm:mt-[37px]"
                style={{ boxShadow: "0px 4px 6px 0px #00000040" }}
              >
                <div className="flex justify-between bg-[#00ADEF1A] px-5 py-4 sm:px-9">
                  <span className=" text-[#303030] font-poppins font-[600] text-[16px] sm:text-[18px] overflow-wrap ">
                    CURRENT PLAN
                  </span>
                  <span className="flex  text-[#303030] font-poppins font-[600] text-[16px] sm:text-[18px] overflow-wrap ">
                    AMOUNT
                  </span>
                </div>
                <div className="px-5 sm:px-9 rounded-bl-[10px] rounded-br-[10px]">
                  <div
                    className="flex justify-between py-9"
                    style={{ borderBottom: "1px solid #DFE1E6" }}
                  >
                    <span className="text-[#303030] font-poppins font-[400] text-[14px]">
                      Upto{" "}
                      {selectedPlan?.duration ? selectedPlan?.duration : (subscriptionPlans.length > 0 ? subscriptionPlans[0]?.duration || "" : "")}
                    </span>
                    <span className="text-[#303030] font-poppins font-[600] text-[14px] ">
                      ${selectedPlan?.amount ? selectedPlan?.amount : (subscriptionPlans.length > 0 ? subscriptionPlans[0]?.amount || "0" : "0")}
                    </span>
                  </div>
                  <div
                    className="flex justify-between py-5"
                    style={{ borderBottom: "1px solid #DFE1E6" }}
                  >
                    <span className="text-[#303030] font-poppins font-[400] text-[14px]">
                      Total
                    </span>
                    <span className="text-[#303030] font-poppins font-[600] text-[14px]">
                      ${selectedPlan?.amount ? selectedPlan?.amount : (subscriptionPlans.length > 0 ? subscriptionPlans[0]?.amount || "0" : "0")}
                    </span>
                  </div>
                  <div className="my-4">
                    <p className="font-poppins font-[400] text-[12px] text-[#8C8C8C]">
                      $14 donated to Red Nose Australia
                    </p>
                  </div>
                </div>
              </div>
              <div className="text-center mt-12">
                <PrimaryButton
                  label={isUpgrade ? "Upgrade Subscription" : "Buy Subscription"}
                  className={
                    "w-[65%] sm:w-[55%] text-[14px] font-[600] h-[40px] sm:h-[40px] md:h-[45px] rounded-[10px]"
                  }
                  onClick={handleSubmit}
                  disabled={!selectedPlan && subscriptionPlans.length === 0}
                />
              </div>
              <div className="mt-12 text-center mb-12">
                <span className="font-[400] text-[14px] font-poppins">
                  By selecting a plan, you agree to our
                  <span
                    className="text-[#00ADEF] font-[400] font-poppins cursor-pointer"
                    onClick={() => window.open("/privacy/toc", "_blank")}
                  >
                    {" "}
                    Terms of Services
                  </span>{" "}
                  and
                  <span
                    className="text-[#00ADEF] font-[400] font-poppins cursor-pointer"
                    onClick={() => window.open("/privacy/policy", "_blank")}
                  >
                    {" "}
                    Privacy Policy
                  </span>
                </span>
              </div>
            </div>
          </div>
          <div className="w-[0%] sm:w-[10%] md:w-[22%] lg:w-[27%] 2xl:w-[30%]"></div>
        </div>
      )}
    </>
  );
}

export default Subscription;
